<template>
    <div>
        <h3>累计转化率分析</h3>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>转化率</span>

                <el-date-picker v-model="period" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :clearable="false" :picker-options="pickerOptions" @change="handleChange"></el-date-picker>
            </div>
            <div>
                <ve-line-chart :data="chartData" :settings="chartSettings" v-bind="options" :loading="loading" />
            </div>
        </el-card>
    </div>
</template>

<script>
import Server from '../../../server';
export default {
    name: 'convert-rate-analytics',
    data() {
        return {
            pickerOptions: {
                disabledDate: this.disabledDate,
                shortcuts: [this.createShortcut('今天', 0), this.createShortcut('昨天', 1), this.createShortcut('最近7天', 7), this.createShortcut('最近半月', 15)],
            },
            chartSettings: {
                label: {
                    show: true,
                    fontSize: '12',
                    fontWeight: 'bold',
                    formatter: params => {
                        // return (params.value[1] * 100).toFixed(2) + "%";
                    },
                },
                smooth: true,
            },
            period: this.periodDate(7),
            chartData: null,
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: value => (value * 100).toFixed(2) + '%',
                        // formatter: (value) => {
                        //     console.log("rate--->", value.toFixed(2));
                        // },
                    },
                    axisPointer: {
                        snap: true,
                    },
                },
            },
            loading: true,
        };
    },
    mounted() {
        this.initData(this.period);
        // this.options = ;
    },
    methods: {
        periodDate(offsetInDays, format) {
            const end = new Date();
            const start = new Date();
            start.setDate(end.getDate() - offsetInDays);
            return [this.$Met.formatDate(start, format), this.$Met.formatDate(end, format)];
        },
        disabledDate(time) {
            return time.getTime() > Date.now();
        },
        getStartAndEndDates(offsetInDays) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * offsetInDays);
            return [start, end];
        },
        createShortcut(text, offsetInDays) {
            return {
                text: text,
                onClick: picker => {
                    picker.$emit('pick', this.getStartAndEndDates(offsetInDays));
                },
            };
        },
        handleChange(dateRange) {
            console.log('change--->', dateRange);
            this.initData(dateRange);
        },
        async initData(period) {
            try {
                this.loading = true;
                const params = {
                    start_date: period[0],
                    end_date: period[1],
                };
                const { data } = await Server.get_rate(params);
                console.log('day data--->', data);
                if (data.code !== 0) throw new Error(data.error);

                const dates = Object.keys(data.userData);

                const calculateArray = source => dates.map(date => (source[date] / data.userData[date]).toFixed(2));

                const textOptimizePromptData = calculateArray(data.textOptimizePromptData);
                const textPromptData = calculateArray(data.textPromptData);
                const visualOptimizeData = calculateArray(data.visualOptimizeData);
                const visualOptimizeMakeImgData = calculateArray(data.visualOptimizeMakeImgData);
                const visualPromptData = calculateArray(data.visualPromptData);
                const visualPromptMakeImgData = calculateArray(data.visualPromptMakeImgData);
                // const combined_data = optimize_data.map((value, index) =>
                //     (
                //         parseFloat(value) + parseFloat(prompt_data[index])
                //     ).toFixed(2)
                // );

                // console.log('Optimize Data:', optimize_data);
                // console.log('Prompt Data:', prompt_data);
                // console.log("Combined Data:", combined_data);

                this.chartData = {
                    dimensions: {
                        name: 'Date',
                        data: dates,
                    },
                    measures: [
                        {
                            name: 'text创建转化率',
                            data: textPromptData,
                        },
                        {
                            name: 'text优化转化率',
                            data: textOptimizePromptData,
                        },
                        {
                            name: 'visual创建转化率',
                            data: visualPromptData,
                        },
                        {
                            name: 'visual创建生成图片转化率',
                            data: visualPromptMakeImgData,
                        },
                        {
                            name: 'visual优化转化率',
                            data: visualOptimizeData,
                        },
                        {
                            name: 'visual优化生成图片转化率',
                            data: visualOptimizeMakeImgData,
                        },
                        // {
                        //     name: "累计转化率",
                        //     data: combined_data,
                        // },
                    ],
                };
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.box-card {
    margin-bottom: 70px;
}
</style>
